import { makeStyles } from '@material-ui/core';
import CheckboxField from 'components/Fields/Checkbox/Checkbox';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { MetaType } from 'store/modules/Meta/types';
import { PolicyType } from 'store/modules/Policies/types';
import selectors from 'store/selectors';

interface ImportPolicyRowProps {
  policy: PolicyType;
  policyTypes?: MetaType[];
  policyProviders?: MetaType[];
  policyPlatforms?: MetaType[];
  index: number;
  removeSelectedPolicy: Function;
  addSelectedPolicy: Function;
}

const useStyles = makeStyles({
  policyRow: {
    paddingLeft: '36px',
    paddingRight: '36px',
    height: '56px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  policyItem: {
    width: '200px',
    height: '56px',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center'
  },
  checkbox: {
    width: '200px',
    height: '56px',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '12px'
  }
});
const ImportPolicyRow = ({
  policy,
  policyTypes,
  policyProviders,
  policyPlatforms,
  index,
  removeSelectedPolicy,
  addSelectedPolicy
}: ImportPolicyRowProps) => {
  const classes = useStyles();
  const [isSelected, setIsSelected] = useState(false);
  const [isJointSelected, setIsJointSelected] = useState(
    policy.owner.is_jointed
  );

  const currentPolicyType = (policyTypes as MetaType[]).find(
    (policyEnum: MetaType) => {
      return Number(policyEnum.value) === policy.type;
    }
  );

  const currentPolicyProvider = (policyProviders as MetaType[]).find(
    (policyProvider: MetaType) => {
      return Number(policyProvider.value) === policy.provider;
    }
  );

  const currentPlatform = (policyPlatforms as MetaType[]).find(
    (policyPlatform: MetaType) => {
      return Number(policyPlatform.value) === policy.platform;
    }
  );

  return (
    <div
      className={classes.policyRow}
      style={{ backgroundColor: index % 2 === 0 ? '#F2F2F2' : 'white' }}
    >
      <div className={classes.checkbox}>
        <CheckboxField
          label=""
          fullWidth={false}
          meta={{
            touched: false,
            invalid: false,
            error: false
          }}
          input={{
            value: isSelected,
            onChange: () => {
              if (isSelected) removeSelectedPolicy(policy);
              else addSelectedPolicy(policy);
              setIsSelected(!isSelected);
            },
            checked: isSelected
          }}
        ></CheckboxField>
      </div>
      <div className={classes.policyItem}>
        {!!currentPolicyType && currentPolicyType.name}
      </div>
      <div className={classes.policyItem}>
        {!!currentPolicyProvider && currentPolicyProvider.name}
      </div>
      <div className={classes.policyItem}>
        {!!currentPlatform && currentPlatform.name}
      </div>
      <div className={classes.checkbox}>
        <CheckboxField
          disabled={true}
          label=""
          fullWidth={false}
          meta={{
            touched: false,
            invalid: false,
            error: false
          }}
          input={{
            value: isJointSelected,
            onChange: () => {
              setIsJointSelected(!isJointSelected);
            },
            checked: isJointSelected
          }}
        ></CheckboxField>
      </div>
    </div>
  );
};

export default connect(
  (state: any) => ({
    policyTypes: selectors.metaSelectors.policyTypes(state),
    policyProviders: selectors.metaSelectors.policyProviders(state),
    policyPlatforms: selectors.metaSelectors.policyPlatforms(state)
  }),
  null
)(ImportPolicyRow);
